var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.$emit('closeErrorPopup')}}},[_c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"tooltip-icon"},[_vm._v("!")]),_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }